/**
 * @generated SignedSource<<6f69804134b53da5619ec933ad68469d>>
 * @relayHash 1835b0c2f34a495024baa4d7304b533a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50865fc00495fd3180245ec98317b5ce584a843d67e9d37fe4401c04204e9fbb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RichTextPopUpContentQuery } from './RichTextPopUpContentQuery.graphql';

import blockAttachmentDownloadSegregation_provider from '@atlassian/jira-relay-provider/src/block-attachment-download-segregation.relayprovider';

const node: PreloadableConcreteRequest<RichTextPopUpContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "50865fc00495fd3180245ec98317b5ce584a843d67e9d37fe4401c04204e9fbb",
    "metadata": {},
    "name": "RichTextPopUpContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcblockattachmentdownloadsegregationrelayprovider": blockAttachmentDownloadSegregation_provider
    }
  }
};

export default node;
